import { useMemo } from 'react'
import { useTypedSelector } from 'src/hooks'

import { getRouteLimits, RouteLimits } from '../helpers/terminalLimits'

/**
 * Хук для получения эффективных лимитов маршрута на основе выбранных терминалов
 * Берет минимальное значение из двух терминалов маршрута
 * Если значение у терминала не задано, используется значение по умолчанию
 */
export const useRouteLimits = (): RouteLimits => {
  const { fromPoint, toPoint } = useTypedSelector((state) => state.orderAddReducer)

  const routeLimits = useMemo(
    () => getRouteLimits(fromPoint.selectedTerminal, toPoint.selectedTerminal),
    [fromPoint.selectedTerminal, toPoint.selectedTerminal]
  )

  return routeLimits
}
